module.exports = __webpack_public_path__ + "img/blue_bay_tv.fd56658a.jpeg";